/*
 * Base Unit
 *
 */
const baseUnit = "10px";

export default baseUnit;
